import React from "react";
import { useLocation } from "react-router-dom";
import NavigationMenu from "../NavigationMenu/NavigationMenu";
import "./Layout.css";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  const pathsWithMenu = ["/main", "/times", "/profile"];
  const shouldShowMenu = pathsWithMenu.some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <div className="panel-layout">
      <div className="safe-area-top" />
      <div className="panel-content">{children}</div>

      <div className="bottom-wrapper">
        {shouldShowMenu && <NavigationMenu />}
        <div className="safe-area-bottom" />
      </div>
    </div>
  );
};

export default Layout;
